// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settlement-select-dialog .ag-header {\n  display: none;\n}\n.settlement-select-dialog .my-custom-quill-editor-send-email .ql-toolbar.ql-snow + .ql-container.ql-snow {\n  height: 150px;\n  resize: vertical;\n  overflow: auto;\n}\n#app #booking-new .booking-details .settlement-select-dialog .el-form-item__content {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
